export { default as translations } from './translations.json';

/**
 * Check if user is subscribed to newsletter.
 * @param {Object|null} user
 * @returns {boolean}
 */
export const isSubscribed = (user) =>
  !!user?.attributes?.profile?.publicData?.newsletterSubscribed;

/**
 * Get user's subscribed lists.
 * @param {Object|null} user
 * @returns {string[]}
 */
export const getSubscribedLists = (user) =>
  user?.attributes?.profile?.publicData?.subscribedLists || [];

/**
 * Check if subscribed to specific list.
 * @param {Object|null} user
 * @param {string} listId
 * @returns {boolean}
 */
export const isSubscribedTo = (user, listId) =>
  getSubscribedLists(user).includes(listId);
